<script lang="ts">
	interface Props {
		color: string;
		shape: 'square' | 'round' | 'fill';
		/** Edge length; legends default to md, compact lists and charts use sm. */
		size?: 'sm' | 'md';
	}

	const { color, shape, size = 'md' }: Props = $props();
</script>

{#if shape === 'fill'}
	<div
		class="patch fill {size}"
		style:background-color="color-mix(in srgb, {color}, transparent 70%)"
		style:border-color={color}>
	</div>
{:else}
	<div class="patch {size}" class:round={shape === 'round'} style:background-color={color}></div>
{/if}

<style>
	.patch {
		flex-shrink: 0;
		width: var(--icon-lg);
		height: var(--icon-lg);

		&.sm {
			width: var(--icon-sm);
			height: var(--icon-sm);
		}

		&.round {
			border-radius: var(--radius-full);
		}

		&.fill {
			border-width: 2px;
			border-style: solid;
		}
	}
</style>
